<template>
    <div class="overflow-x-auto">
        <table class="table">
            <thead>
                <tr>
                    <th>Namn</th>
                    <th>Adress</th>
                    <th>Status</th>
                    <th>Projekt</th>
                    <th />
                </tr>
            </thead>
            <tbody>
                <tr v-for="address in addresses">
                    <td>
                        {{ address.customer ? address.customer.name : '' }}
                    </td>
                    <td>
                        <a v-if="address.sales_project" :href="getAddressUrl(address)">{{ address.street_address }}</a>
                        <span v-else>{{ address.street_address }}</span>
                    </td>
                    <td>
                        <div :class="`text-${address.status_color}`" class="mt-xs flex">
                            <!-- eslint-disable vue/no-v-html -->
                            <div class="flex items-center mr-sm" v-html="address.status_dot" />
                            {{ address.status_label }}
                        </div>
                    </td>
                    <td>
                        <a v-if="address.sales_project" :href="getProjectUrl(address)">{{ address.sales_project.name }}</a>
                        <span v-else>{{ address.street_address }}</span>
                    </td>
                    <td class="flex justify-between">
                        <request-customer-excerpt-button
                            v-if="address.customer && authorizedToRequestExcerpt"
                            :customer="address.customer"
                            size="small"
                            class="mr-lg"
                        >
                            Registerutdrag
                        </request-customer-excerpt-button>

                        <anonymize-customer-button
                            v-if="address.customer && authorizedToAnonymize"
                            :customer="address.customer"
                            size="small"
                            @updated="updateAddresses"
                        />
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
    export default {
        props: {
            addresses: {
                type: Array,
                required: true,
            },
            authorizedToAnonymize: {
                required: true,
                type: Boolean,
            },
            authorizedToRequestExcerpt: {
                required: true,
                type: Boolean,
            },
        },

        methods: {
            updateAddresses() {
                this.$emit('addresses-updated');
            },

            getAddressUrl(address) {
                if (address.sales_project) {
                    return route('admin.sales-projects.addresses.show', [address.sales_project, address.id]);
                }

                return '';
            },

            getProjectUrl(address) {
                if (address.sales_project) {
                    return route('admin.sales-projects.show', address.sales_project);
                }

                return '';
            },
        },
    };
</script>
